import { i18n } from '@lt/localization';

/**
 * дата в формате 02.01.2019
 */
export const DATE_FORMAT_CLIENT = 'dd.MM.yyyy';

/**
 * дата в формате 28 мая, пт
 */
export const DATE_FORMAT_WITH_DAY_OF_WEEK = 'd MMM, EEEEEE';

/**
 * дата в формате 2 янв 2019 в 12:50
 */
export const DATE_FULL_DATE = 'd MMM yyyy в HH:mm';

export const HOT_PRICE_HINT_TEXT = i18n.t('hotel.offer.hotPrice');
export const INSTANT_CONFIRM_HINT_TEXT = i18n.t('hotel.offer.instant');

export const SKELETON_ANIMATION_DELAY = 300; // ms
export const SKELETON_ANIMATION_DURATION = 1200; // ms

export const NBSP = String.fromCharCode(160);
export const NDASHS = '-';
export const NIGHT_WORD_FORMS = [
  i18n.t('hotel.offer.night', { count: 0 }),
  i18n.t('hotel.offer.night', { count: 1 }),
  i18n.t('hotel.offer.night', { count: 2 }),
];
